module.exports = __webpack_public_path__ + "img/logo_aos.0b0d30ee.jpg";